/* eslint-disable new-cap */
/* eslint-disable camelcase */
import ABCyaPhaser, { Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AudioPlayer from '../library/AudioPlayer';

export default class Doors {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    this.scene = scene;
    this.shakeCameraTimer = null;

    this.rightDoor = new Phaser.GameObjects.Sprite(this.scene, this.scene.scale.width, this.scene.scale.height * .5 - 10, Images.DEFAULT_ATLAS, 'rightDoor');
    this.leftDoor = new Phaser.GameObjects.Container(this.scene, -581, this.scene.scale.height * .5 - 10);
    const leftDoorBg = new Phaser.GameObjects.Sprite(this.scene, 0,0, Images.DEFAULT_ATLAS, 'leftDoor');
    this.leftDoor.add(leftDoorBg);
    this.leftDoor.setSize(leftDoorBg.width, leftDoorBg.height);
    const leftDoorText = new Phaser.GameObjects.BitmapText(this.scene, -90,55, 'Nasalization', ABCyaPhaser.Localization.instance.getLocalizedString('loading_text'), 48).setTint(0x99fe7b);
    this.leftDoor.add(leftDoorText);
    ABCyaPhaser.Text.resizeFontToFitWidth(leftDoorText, 280, 55);

    this.doorPositions = {
      right_In: this.scene.scale.width * .5 + this.rightDoor.width * .5,
      left_In: this.leftDoor.width * .5,
      right_Out: this.scene.scale.width + this.rightDoor.width * .5,
      left_Out: - this.leftDoor.width * .5
    };

    this.rightX_Out = this.scene.scale.width + this.rightDoor.width;
    this.rightDoor.x += this.rightDoor.width;

    this.scene.add.existing(this.rightDoor);
    this.scene.add.existing(this.leftDoor);
  }

  AnimateIn() {
    AudioPlayer.PlaySound(this.scene, AudioPlayer.sounds.DOOR_CLOSE);

    Tweens.addTween(this.rightDoor, 1000, { x: this.doorPositions.right_In }, Phaser.Math.Easing.Bounce.Out);
    const timingTween = Tweens.addTween(this.leftDoor, 1000, { x: this.doorPositions.left_In, completeDelay: 600 }, Phaser.Math.Easing.Bounce.Out);

    this.scene.time.addEvent({ delay: 400, callback: () => {this.shakeCamera();} });

    return timingTween;
  }

  AnimateOut() {
    AudioPlayer.PlaySound(this.scene, AudioPlayer.sounds.DOOR_OPEN);

    Tweens.addTween(this.rightDoor, 1000, { x: this.doorPositions.right_Out }, Phaser.Math.Easing.Exponential);
    const timingTween = Tweens.addTween(this.leftDoor, 1000, { x: this.doorPositions.left_Out }, Phaser.Math.Easing.Exponential);
    return timingTween;
  }

  shakeCamera() {
    this.scene.cameras.main.shake(600, .02);
  }
}


